'use strict';

angular.module('shiftTraderApp')
  .controller('WorkPeriodsCtrl', function ($scope, WorkPeriods, TimeService, Session,
                                           me, upcomingWorkPeriods, selectedUser, $uibModal) {
    $scope.upcomingWorkPeriods = _.sortBy(_.where(upcomingWorkPeriods, function(wp) {
      return wp.$isPublished() && wp.active;
    }), '_startTimeUnix');

    var departments = me.memberships[0].organization.departments;
    _.map($scope.upcomingWorkPeriods, function(wp) {
      var deptId = wp.position.department_id;
      if (_.isNull(deptId)) {
        wp.position._department_name = '';
      } else {
        var dept = _.find(departments, {id: deptId});
        if (!_.isUndefined(dept)) {
          wp.position._department_name = dept.name;
        }
      }
      return wp;
    });

    $scope.me = me;
    $scope.selectedUser = selectedUser;

    $scope.state = {
      showSelector: 'true',
      pastQueryStartDate: moment(TimeService.getNowInStoreTime()).subtract(6, 'months').hour(0).minutes(0).seconds(0).toDate(),
      pastQueryEndDate: moment(TimeService.getNowInStoreTime()).hour(0).minutes(0).seconds(0).add(24, 'hours').subtract(1, 'second').toDate()
    };

    $scope.startOfWeekDay = Session.getStartOfWeekDay();
    $scope.datePickerOptions = {
      startingDay: $scope.startOfWeekDay,
      showWeeks: false
    };

    $scope.datepickers = {
      startDateOpened: false,
      endDateOpened: false
    };


    $scope.openStartDate = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      if ($scope.datepickers.startDateOpened === true) {
        $scope.datepickers.startDateOpened = false;
      } else {
        $scope.datepickers.startDateOpened = true;
      }
    };

    $scope.openEndDate = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      if ($scope.datepickers.endDateOpened === true) {
        $scope.datepickers.endDateOpened = false;
      } else {
        $scope.datepickers.endDateOpened = true;
      }
    };

    var getPastWorkPeriods = function() {
      var data = {
        published: true,
        start_time: moment($scope.state.pastQueryStartDate).format(),
        end_time: moment($scope.state.pastQueryEndDate).format()
      };

      WorkPeriods.getByUserId($scope.mySchedule ? $scope.me.id : $scope.selectedUser[0].id, data)
          .then(function(workPeriods) {
            $scope.pastWorkPeriods = _.sortBy(_.where(workPeriods, function(wp) {
              return wp.active && wp.$isPublished();
            }), function(wp) {
              return -1 * wp._startTimeUnix;
            });

          }, function(response) {

          });
    };

    $scope.mySchedule = (function() {
      if ($scope.selectedUser.length > 0) {
        return $scope.selectedUser[0].id === me.id;
      } else {
        return true;
      }
    })();

    $scope.setShow = function(val) {
      $scope.state.showSelector = val;

      // check if you're logged in here, as the $destroy method of the tabset used for setting showSelector calls
      //   $scope.setShow, firing getPastWorkPeriods w/ an error
      if ($scope.state.showSelector === 'false' && Session.isLoggedIn()) {
        getPastWorkPeriods();
      }
    };

    _.each(['state.pastQueryStartDate', 'state.pastQueryEndDate'], function(prop) {
      $scope.$watch(prop, function(newVal, oldVal) {
        if (newVal !== oldVal) {
          getPastWorkPeriods();
        }
      });
    });


    $scope.openRequestDayOffModal = function() {
      var modalInstance = $uibModal.open({
        size: 'request-day-off',
        templateUrl: 'views/daysOff/requestDayOffModal.html',
        controller: 'RequestDayOffModalCtrl',
        resolve: {
          params: function() {
            return {
              me: $scope.me,
              user: $scope.me
            };
          }
        }
      });
      modalInstance.result.then(function(result) {
          console.log('closed manage blackout dates modal' + result);
        },
        function(reason) {
          console.log('dismissed explanation with reason ' + reason);

        });
    };

  });
